var redirectWithDelay = function redirectWithDelay(url) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  return setTimeout(function () {
    window.location.href = url;
  }, ms);
};

export { redirectWithDelay as default };
//# sourceMappingURL=index.js.map
